import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-24 ss-alinhar-desktop-direita-mobile-centro" }
const _hoisted_3 = { class: "ant-btn-group" }
const _hoisted_4 = { class: "ant-btn ant-btn-secondary ss-botoes-icones" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "ss-alinhar-centro" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Teclas de Atalho - Grade de Itens")
], -1)
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_8 = {
  key: 0,
  class: "acoes-item"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 4,
  style: {"font-size":"14px"}
}
const _hoisted_11 = {
  key: 9,
  style: {"font-size":"14px"}
}
const _hoisted_12 = {
  key: 10,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  class: "acoes-item",
  style: {"margin-top":"2px"}
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_selecionar_produto_movimento = _resolveComponent("selecionar-produto-movimento")!
  const _component_selecionar_unidade_produto_movimento = _resolveComponent("selecionar-unidade-produto-movimento")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_pedido_compra_item_modal = _resolveComponent("pedido-compra-item-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.props.editavel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_a_tooltip, {
                title: "Inserir Item",
                placement: "left"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    class: "ant-btn ant-btn-secondary ss-acao-destaque-secundaria",
                    style: {"margin-top":"4px"},
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.novoItemGrade(true)))
                  }, "Inserir item")
                ]),
                _: 1
              }),
              _createVNode(_component_a_dropdown, null, {
                overlay: _withCtx(() => [
                  _createVNode(_component_a_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tag, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Shift + N")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Adicionar novo Item ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tag, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Shift + E")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Editar detalhes do produto ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tag, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Shift + D")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Distribuição de estoques ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tag, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Shift + DEL")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Deletar um item ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tag, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Shift + TAB")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Campo anterior ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tag, null, {
                            default: _withCtx(() => [
                              _createTextVNode("TAB")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Próximo campo ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tag, null, {
                            default: _withCtx(() => [
                              _createTextVNode("↑")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Campo acima ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tag, null, {
                            default: _withCtx(() => [
                              _createTextVNode("↓")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Campo abaixo ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_a_tooltip, {
                    title: "Teclas de Atalho",
                    placement: "left"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", _hoisted_4, [
                        _createVNode(_component_icone, {
                          style: {"margin-top":"2px"},
                          nome: "ajuda"
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(), _createBlock(_component_a_table, {
          key: _ctx.props.chaveItens,
          columns: _ctx.state.colunasGrade.filter(item => item.visible),
          "data-source": _ctx.computedItens,
          rowKey: "codigo",
          pagination: false,
          scroll: { y: 200},
          size: "small",
          rowClassName: "ss-table-campos",
          bordered: ""
        }, {
          emptyText: _withCtx(() => [
            _createVNode(_component_mensagem_sem_dados, { mensagem: "Nenhum item adicionado ainda" })
          ]),
          bodyCell: _withCtx(({ column, record, index }) => [
            (column.key === 'acoes')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_ctx.props.editavel)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "excluir",
                        onClick: ($event: any) => (_ctx.confirmarExclusao(index))
                      }, [
                        _createVNode(_component_icone, { nome: "excluir" })
                      ], 8, _hoisted_9))
                    : _createCommentVNode("", true)
                ]))
              : (column.key === 'Produto')
                ? (_openBlock(), _createBlock(_component_selecionar_produto_movimento, {
                    key: 1,
                    classCss: "hidden ss-campo-selecao-table ss-recebimento-mercadoria-itens",
                    classGroupCss: "ss-campo-selecao-table",
                    title: column.title,
                    dataAttributeColuna: column.key,
                    empresas: [_ctx.empresa],
                    buscarDadosAtualizados: _ctx.props.editavel,
                    codigoSelecionado: record.codigoProdutoDefinicao,
                    "onUpdate:codigoSelecionado": ($event: any) => ((record.codigoProdutoDefinicao) = $event),
                    descricao: record.descricaoProduto,
                    "onUpdate:descricao": ($event: any) => ((record.descricaoProduto) = $event),
                    codigoNcm: record.imposto.codigoNcm,
                    "onUpdate:codigoNcm": ($event: any) => ((record.imposto.codigoNcm) = $event),
                    emDigitacao: record.emDigitacao,
                    "onUpdate:emDigitacao": ($event: any) => ((record.emDigitacao) = $event),
                    codigoInterno: record.codigoInternoProduto,
                    disabled: !_ctx.props.editavel,
                    limparSelecao: false,
                    onKeydown: [
                      _withKeys(_withModifiers(($event: any) => (_ctx.editarItem(index)), ["shift","exact","prevent"]), ["e"]),
                      _withKeys(_withModifiers(($event: any) => (_ctx.confirmarExclusao(index,$event)), ["shift","exact","prevent"]), ["delete"]),
                      _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent","shift"]), ["tab"])),
                      _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoEsquerda(record.emDigitacao, $event)), ["prevent"]), ["left"]),
                      _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoDireita(record.emDigitacao, $event)), ["prevent"]), ["right"]),
                      _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoAbaixo(record.emDigitacao, $event, column.key)), ["prevent"]), ["down"]),
                      _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoAcima(record.emDigitacao, $event, column.key)), ["prevent"]), ["up"])
                    ],
                    onKeyup: [
                      _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["exact"]), ["enter"])),
                      _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["exact"]), ["tab"]))
                    ]
                  }, null, 8, ["title", "dataAttributeColuna", "empresas", "buscarDadosAtualizados", "codigoSelecionado", "onUpdate:codigoSelecionado", "descricao", "onUpdate:descricao", "codigoNcm", "onUpdate:codigoNcm", "emDigitacao", "onUpdate:emDigitacao", "codigoInterno", "disabled", "onKeydown"]))
                : (column.key === 'Unidade')
                  ? (_openBlock(), _createBlock(_component_selecionar_unidade_produto_movimento, {
                      classCss: "hidden ss-campo-selecao-table ss-recebimento-mercadoria-itens",
                      classGroupCss: "ss-campo-selecao-table",
                      apenasUnidadePrincipal: true,
                      title: record.descricaoUnidade,
                      codigoProdutoDefinicao: record.codigoProdutoDefinicao,
                      editavel: _ctx.props.editavel,
                      disabled: !_ctx.props.editavel,
                      codigoUnidadeSelecionada: record.unidade,
                      "onUpdate:codigoUnidadeSelecionada": ($event: any) => ((record.unidade) = $event),
                      sigla: record.siglaUnidade,
                      "onUpdate:sigla": ($event: any) => ((record.siglaUnidade) = $event),
                      apresentarApenasSigla: true,
                      key: ('UNIDADE' + record.codigoProdutoDefinicao + _ctx.props.chaveItens + index),
                      onValorDigitado: ($event: any) => (_ctx.salvarItemGrade(index,record)),
                      onKeydown: [
                        _withKeys(_withModifiers(($event: any) => (_ctx.editarItem(index)), ["shift","exact","prevent"]), ["e"]),
                        _withKeys(_withModifiers(($event: any) => (_ctx.confirmarExclusao(index,$event)), ["shift","exact","prevent"]), ["delete"]),
                        _cache[6] || (_cache[6] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent","shift"]), ["tab"])),
                        _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoEsquerda(record.emDigitacao, $event)), ["prevent"]), ["left"]),
                        _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoDireita(record.emDigitacao, $event)), ["prevent"]), ["right"]),
                        _withKeys(_withModifiers(($event: any) => (_ctx.elementoAbaixo($event,column.key)), ["prevent"]), ["down"]),
                        _withKeys(_withModifiers(($event: any) => (_ctx.elementoAcima($event,column.key)), ["prevent"]), ["up"])
                      ],
                      onKeyup: [
                        _cache[4] || (_cache[4] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["exact"]), ["tab"])),
                        _cache[5] || (_cache[5] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["exact"]), ["enter"]))
                      ]
                    }, null, 8, ["title", "codigoProdutoDefinicao", "editavel", "disabled", "codigoUnidadeSelecionada", "onUpdate:codigoUnidadeSelecionada", "sigla", "onUpdate:sigla", "onValorDigitado", "onKeydown"]))
                  : (column.key === 'Quantidade')
                    ? (_openBlock(), _createBlock(_component_campo_numerico, {
                        dataAttributeColuna: 'Quantidade',
                        title: 'Quantidade',
                        classCss: "hidden ss-campo-numero-table ss-recebimento-mercadoria-itens",
                        classGroupCss: "hidden ss-campo-numero-table ant-input",
                        valor: record.quantidade,
                        "onUpdate:valor": ($event: any) => ((record.quantidade) = $event),
                        emDigitacao: record.emDigitacao,
                        "onUpdate:emDigitacao": ($event: any) => ((record.emDigitacao) = $event),
                        disabled: !_ctx.props.editavel,
                        key: ('QTDE' + record.codigoProdutoDefinicao + _ctx.props.chaveItens + index),
                        quantidadeCasasDecimais: 6,
                        onValorDigitado: ($event: any) => (_ctx.salvarItemGrade(index,record)),
                        onKeyup: _cache[7] || (_cache[7] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["exact"]), ["enter"])),
                        onKeydown: [
                          _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoEsquerda(record.emDigitacao, $event)), ["prevent"]), ["left"]),
                          _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoDireita(record.emDigitacao, $event)), ["prevent"]), ["right"]),
                          _cache[8] || (_cache[8] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAbaixo($event, 'Quantidade')), ["prevent"]), ["down"])),
                          _cache[9] || (_cache[9] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAcima($event, 'Quantidade')), ["prevent"]), ["up"]))
                        ]
                      }, null, 8, ["valor", "onUpdate:valor", "emDigitacao", "onUpdate:emDigitacao", "disabled", "onValorDigitado", "onKeydown"]))
                    : (column.key === 'QuantidadeAtendida')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.quantidadeAtendida + record.quantidadeCortada, 6)), 1))
                      : (column.key === 'ValorUnitario')
                        ? (_openBlock(), _createBlock(_component_campo_numerico, {
                            key: 5,
                            dataAttributeColuna: column.key,
                            valor: record.valorUnitario,
                            "onUpdate:valor": ($event: any) => ((record.valorUnitario) = $event),
                            monetario: true,
                            quantidadeCasasDecimais: 6,
                            disabled: !_ctx.props.editavel,
                            classCss: "ss-campo-numero-table hidden ss-recebimento-mercadoria-itens",
                            classGroupCss: "hidden ss-campo-numero-table",
                            onValorDigitado: ($event: any) => (_ctx.salvarItemGrade(index,record)),
                            onKeydown: [
                              _withKeys(_withModifiers(($event: any) => (_ctx.editarItem(index)), ["shift","exact","prevent"]), ["e"]),
                              _withKeys(_withModifiers(($event: any) => (_ctx.confirmarExclusao(index,$event)), ["shift","exact","prevent"]), ["delete"]),
                              _cache[11] || (_cache[11] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent","shift"]), ["tab"])),
                              _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoEsquerda(record.emDigitacao, $event)), ["prevent"]), ["left"]),
                              _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoDireita(record.emDigitacao, $event)), ["prevent"]), ["right"]),
                              _withKeys(_withModifiers(($event: any) => (_ctx.elementoAbaixo($event, column.key)), ["prevent"]), ["down"]),
                              _withKeys(_withModifiers(($event: any) => (_ctx.elementoAcima($event, column.key)), ["prevent"]), ["up"])
                            ],
                            onKeyup: _cache[10] || (_cache[10] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["exact"]), ["enter"]))
                          }, null, 8, ["dataAttributeColuna", "valor", "onUpdate:valor", "disabled", "onValorDigitado", "onKeydown"]))
                        : (column.key === 'Ipi')
                          ? (_openBlock(), _createBlock(_component_campo_numerico, {
                              key: 6,
                              dataAttributeColuna: column.key,
                              valor: record.imposto.aliquotaIpi,
                              "onUpdate:valor": ($event: any) => ((record.imposto.aliquotaIpi) = $event),
                              percentual: true,
                              disabled: !_ctx.props.editavel,
                              classCss: "ss-campo-numero-table hidden ss-recebimento-mercadoria-itens",
                              classGroupCss: "hidden ss-campo-numero-table",
                              onValorDigitado: ($event: any) => (_ctx.salvarItemGrade(index,record)),
                              onKeydown: [
                                _withKeys(_withModifiers(($event: any) => (_ctx.editarItem(index)), ["shift","exact","prevent"]), ["e"]),
                                _withKeys(_withModifiers(($event: any) => (_ctx.confirmarExclusao(index,$event)), ["shift","exact","prevent"]), ["delete"]),
                                _cache[13] || (_cache[13] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","stop"]), ["tab"])),
                                _cache[14] || (_cache[14] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent","shift"]), ["tab"])),
                                _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoEsquerda(record.emDigitacao, $event)), ["prevent"]), ["left"]),
                                _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoDireita(record.emDigitacao, $event)), ["prevent"]), ["right"]),
                                _withKeys(_withModifiers(($event: any) => (_ctx.elementoAbaixo($event, column.key)), ["prevent"]), ["down"]),
                                _withKeys(_withModifiers(($event: any) => (_ctx.elementoAcima($event, column.key)), ["prevent"]), ["up"])
                              ],
                              onKeyup: _cache[12] || (_cache[12] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["exact"]), ["enter"]))
                            }, null, 8, ["dataAttributeColuna", "valor", "onUpdate:valor", "disabled", "onValorDigitado", "onKeydown"]))
                          : (column.key === 'Desconto')
                            ? (_openBlock(), _createBlock(_component_campo_numerico, {
                                key: 7,
                                dataAttributeColuna: column.key,
                                valor: record.desconto,
                                "onUpdate:valor": ($event: any) => ((record.desconto) = $event),
                                monetario: true,
                                disabled: !_ctx.props.editavel,
                                classCss: "hidden ss-campo-numero-table ss-recebimento-mercadoria-itens",
                                classGroupCss: "hidden ss-campo-numero-table",
                                onValorDigitado: ($event: any) => (_ctx.salvarItemGrade(index,record)),
                                onKeydown: [
                                  _withKeys(_withModifiers(($event: any) => (_ctx.editarItem(index)), ["shift","exact","prevent"]), ["e"]),
                                  _withKeys(_withModifiers(($event: any) => (_ctx.confirmarExclusao(index,$event)), ["shift","exact","prevent"]), ["delete"]),
                                  _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoProximoElementoDesconto(record.emDigitacao, index, $event)), ["prevent","exact"]), ["tab"]),
                                  _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoProximoElementoDesconto(record.emDigitacao, index, $event)), ["prevent","exact"]), ["enter"]),
                                  _cache[15] || (_cache[15] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent","shift"]), ["tab"])),
                                  _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoEsquerda(record.emDigitacao, $event)), ["prevent"]), ["left"]),
                                  _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoDireita(record.emDigitacao, $event)), ["prevent"]), ["right"]),
                                  _withKeys(_withModifiers(($event: any) => (_ctx.elementoAbaixo($event, column.key)), ["prevent"]), ["down"]),
                                  _withKeys(_withModifiers(($event: any) => (_ctx.elementoAcima($event, column.key)), ["prevent"]), ["up"])
                                ]
                              }, null, 8, ["dataAttributeColuna", "valor", "onUpdate:valor", "disabled", "onValorDigitado", "onKeydown"]))
                            : (column.key === 'Total')
                              ? (_openBlock(), _createBlock(_component_campo_numerico, {
                                  key: 8,
                                  title: column.title,
                                  valor: record.valorTotal,
                                  quantidadeCasasDecimais: 2,
                                  monetario: true,
                                  disabled: true,
                                  classGroupCss: "hidden ss-campo-numero-table",
                                  classCss: "hidden ss-campo-numero-table"
                                }, null, 8, ["title", "valor"]))
                              : (column.key === 'Status')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.obterStatusItem(index)), 1))
                                : (column.key === 'Item')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                      _createElementVNode("span", null, [
                                        _createElementVNode("a", {
                                          onClick: ($event: any) => (_ctx.editarItem(index))
                                        }, [
                                          _createElementVNode("span", null, _toDisplayString(record.descricao), 1)
                                        ], 8, _hoisted_13)
                                      ]),
                                      _createElementVNode("span", null, "Quantidade: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.quantidade, 2)) + "(" + _toDisplayString(record.descricaoUnidade) + ") ", 1),
                                      _createElementVNode("span", null, "Vlr Unitário: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.valorUnitario, 2, true)), 1),
                                      _createElementVNode("span", null, "Desconto: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.desconto, 2, true)), 1),
                                      _createElementVNode("span", null, "Total: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.valorTotal, 2, true)), 1),
                                      _createElementVNode("div", _hoisted_14, [
                                        _createElementVNode("a", {
                                          class: "visualizar",
                                          onClick: ($event: any) => (_ctx.editarItem(index))
                                        }, [
                                          _createVNode(_component_icone, { nome: "editar" })
                                        ], 8, _hoisted_15),
                                        (_ctx.props.editavel)
                                          ? (_openBlock(), _createElementBlock("a", {
                                              key: 0,
                                              class: "excluir",
                                              onClick: ($event: any) => (_ctx.confirmarExclusao(index))
                                            }, [
                                              _createVNode(_component_icone, { nome: "excluir" })
                                            ], 8, _hoisted_16))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["columns", "data-source"]))
      ])
    ]),
    _createVNode(_component_pedido_compra_item_modal, {
      visivel: _ctx.state.exibirDetalhesItem,
      empresa: _ctx.props.empresa,
      editavel: _ctx.props.editavel,
      item: _ctx.state.itemSelecionado,
      "onUpdate:item": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.itemSelecionado) = $event)),
      totalNota: _ctx.props.totalPedido,
      existeAnterior: _ctx.state.existeAnterior,
      existeProximo: _ctx.state.existeProximo
    }, null, 8, ["visivel", "empresa", "editavel", "item", "totalNota", "existeAnterior", "existeProximo"])
  ]))
}